// extracted by mini-css-extract-plugin
export default {"offerResume":"CollectionItem_offerResume__LWSgx","onSaleBadge":"CollectionItem_onSaleBadge__E7hqL","imgContainer":"CollectionItem_imgContainer__e7w8p"};